import { TStatusBadgeCategory } from '../../../pages/items/items.interface';

/** Status names the work instruction templates translate ("workInstructionStepper.status.ongoing"). */
export enum EWorkInstructionStatus {
  completed = 'completed',
  ongoing = 'ongoing',
  paused = 'paused',
  notStarted = 'notStarted',
}

export interface IWorkInstructionStatus {
  completedStepCount: number;
  totalStepCount: number;
  percentage: number;
  status: EWorkInstructionStatus;
  statusCategory: TStatusBadgeCategory;
  isLate: boolean;
}
